export default "__VITE_ASSET__W70yycd3__"